export default __webpack_public_path__ + "static/media/dairy_cat.ab1f0e43.jpg";